import { createContext, Dispatch } from 'react';
import { FilterGroupAction, FilterState, getDefaultState } from '../reducers/filterStatement/filterStatementReducer';

export const FilterContext = createContext<FilterState>(getDefaultState({ teamId: -1 }));

export const FilterDispatchContext = createContext<Dispatch<FilterGroupAction>>(() => {
  throw new Error('FilterDispatchContext not initialized');
});
